<template>
  <div class="page withdraw-protocol">
    <!-- <navigation>相关协议</navigation> -->
    <nd-cell class="navigate-item"
             v-for="(item, index) in protocolList"
             :key="index"
             :title="item.title"
             @click="clickProtocol(item)"
    >
    </nd-cell>
  </div>
</template>
<script>
export default {
  name: 'weibo-protocol',
  data () {
    return {
      protocolList: [],
      type: this.$route.query.type
    }
  },
  async created () {
    if (this.type === 'credit') {
      this.protocolList = [
        {
          path: 'https://tmd.ndmicro.com/weibo/login',
          title: '天美贷平台用户注册协议'
        },
        {
          path: 'https://tmd.ndmicro.com/protocol/authorization',
          title: '崇天小贷-授权查询协议'
        },
        {
          path: 'https://tmd.ndmicro.com/weibo/privacy',
          title: '个人信息保护政策'
        }
      ]
    } else if (this.type === 'payment') {
      this.protocolList = [
        {
          path: 'https://tmd.ndmicro.com/protocol/entrust',
          title: '崇天小贷-委托扣款协议'
        }
      ]
    } else if (this.type === 'cash') {
      this.protocolList = [
        {
          path: 'https://tmd.ndmicro.com/protocol/loan-instruction',
          title: '借款须知及风险提示'
        },
        {
          path: 'https://pro.ndmicro.com/protocol/tmd/jx/authorization',
          title: '个人信用信息查询及报送授权书'
        },
        {
          path: 'https://pro.ndmicro.com/protocol/tmd/dxal/loan',
          title: '借款合同'
        },
        {
          path: 'https://pro.ndmicro.com/protocol/tmd/dxal/query-entrust',
          title: '个人征信信息查询授权书及个人信息使用授权书'
        },
        {
          path: 'https://pro.ndmicro.com/protocol/tmd/dxal/guarantee',
          title: '委托担保合同'
        }
      ]
    }
  },
  methods: {
    clickProtocol (item) {
      if (item.path.includes('https://tmd.ndmicro.com')) {
        this.$router.push(item.path.replace('https://tmd.ndmicro.com', ''))
      } else {
        window.location.href = item.path
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.withdraw-protocol {
    background-color: #fafafa;
      .navigate-item {
          height: 110px;
          line-height: 1.5;
          margin-top: 0px;
          padding-left: 15px;
          padding-right: 17px;
          border-bottom: 1px solid @iuc;
      }
}
</style>

